import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { fetchGet, fetchDatassss, fetchDocData, fetchDocData1, fetchDocData2, fetchDocData3 } from '../reduxactions/suprivisoractions/SupDocReportsActions';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { RootState } from '../reducers';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import useEffectOnce from '../hooks/useEffectOnce';
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

export const SupViewDoctoeReports = () => {
    const uid = window.sessionStorage.getItem('uid');
    const [globalFilter, setGlobalFilter] = useState('');
    const stepperRef = useRef(null);

    const [activeIndex, setActiveIndex] = useState(0);

    const location = useLocation();
    const dispatch = useDispatch();

    const [queryParams, setQueryParams] = useState(null);
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setQueryParams(params.get("id") as any);
    }, [location]);
    const { id } = useParams();
    const getdata = useSelector((state: RootState) => state.sviewdocreports.get);
    const data = useSelector((state: RootState) => state.sviewdocreports.data);
    const dataoffetch = useSelector((state: RootState) => state.sviewdocreports.doc);
    const doc1 = useSelector((state: RootState) => state.sviewdocreports.doc1);
    const doc2 = useSelector((state: RootState) => state.sviewdocreports.doc2);
    const doc3 = useSelector((state: RootState) => state.sviewdocreports.doc3);


    //To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchGet(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDataAsync1 = async () => {
        try {
            await dispatch(fetchDatassss(id) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    //To get data
    const fetchDataAsync2 = async () => {
        try {
            await dispatch(fetchDocData(id) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDataAsync3 = async () => {
        try {
            await dispatch(fetchDocData1(id) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    //To get data
    const fetchDataAsync4 = async () => {
        try {
            await dispatch(fetchDocData2(id) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDataAsync5 = async () => {
        try {
            await dispatch(fetchDocData3(id) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffectOnce(() => {
        fetchDataAsync();
        fetchDataAsync1();
        fetchDataAsync2();
        fetchDataAsync3();
        fetchDataAsync4();
        fetchDataAsync5();
    }, [dispatch]);
    const navigate = useNavigate();
    const ViewCase = (rowData: any) => {
        const url = `/viewdoctorcases/${rowData.CaseID}`;
        navigate(url);
    }

    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/viewsup-reports.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };

    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        <div className="col-16" style={{ textAlign: "right" }}>
                            <a
                                title="help"
                                onClick={(e) => openWindow(e, IUrl)}
                                style={{

                                    color: "blue",
                                    fontSize: 15, cursor: "pointer"
                                }}
                            >Help for this Page &nbsp;
                                <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                            </a>
                        </div>
                        <section className="content">
                            {data.map((response: any) =>
                                <>
                                    <div className="grid">
                                        <div className="col-3">
                                            <Card style={{ width: '350px' }}>
                                                <div className="widget-user-header bg-info" style={{ height: '120px', backgroundColor: 'rgb(23, 162, 184)', borderRadius: '3px 3px 0 0', position: 'relative', display: 'flex', flexDirection: 'column', width: '113%', justifyContent: 'center', alignItems: 'center', marginLeft: '-20px', marginTop: '-40px' }}>
                                                    <h2 className="widget-user-username" style={{ color: 'rgb(255, 255, 255)', fontSize: '25px', fontWeight: '200', marginBottom: '60px' }}>Doctors</h2>
                                                    <img src={response.photo} alt="User Avatar" style={{ width: '100px', height: '70px', borderRadius: '50%', position: 'absolute', bottom: '-20px', left: '50%', transform: 'translateX(-50%)', border: '4px solid white' }} />
                                                </div>

                                                <div style={{ display: 'flex', flexDirection: 'row', gap: '20px', marginLeft: '-10px' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: '10px' }}>
                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', width: '50px', paddingTop: '10px' }}>
                                                            <h4 style={{ fontWeight: '500', textAlign: 'center' }}>CASES</h4>
                                                            <p className="text-muted"
                                                                style={{
                                                                    borderRadius: '6px',
                                                                    textAlign: 'center',
                                                                    padding: '5px 10px',
                                                                    margin: 0,
                                                                    width: '100%',
                                                                }}
                                                            >
                                                                {response.cases}
                                                            </p>
                                                        </div>
                                                        <div style={{ width: '1px', height: '100px', backgroundColor: '#ccc' }}></div>

                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', width: '140px', paddingTop: '10px' }}>
                                                            <h4 style={{ fontWeight: '500' }}>APPOINTMENTS</h4>
                                                            <p
                                                                className="text-muted"
                                                                style={{
                                                                    borderRadius: '6px',
                                                                    textAlign: 'center',
                                                                    padding: '5px 10px',
                                                                    margin: 0,
                                                                    width: '100%',
                                                                }}
                                                            >
                                                                {response.appointments}
                                                            </p>
                                                        </div>
                                                        <div style={{ width: '1px', height: '100px', backgroundColor: '#ccc' }}></div>

                                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', width: '90px', paddingTop: '10px' }}>
                                                            <h4 style={{ fontWeight: '500', textAlign: 'center' }}>ASSISTANTS</h4>
                                                            <p
                                                                className="text-muted"
                                                                style={{
                                                                    borderRadius: '6px',
                                                                    textAlign: 'center',
                                                                    padding: '5px 10px',
                                                                    margin: 0,
                                                                    width: '100%',
                                                                }}
                                                            >
                                                                {response.assistants}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Card>
                                        </div>

                                    </div>
                                    <Stepper ref={stepperRef}>
                                        <StepperPanel header="Doctor Details">
                                            <div className="col-12" style={{ minHeight: '400px', marginTop: '0' }}>

                                                {dataoffetch.map((response: any, index: number) => (
                                                    <section className="content" key={index}>
                                                        <Card>
                                                            <div className="grid">
                                                                <div className="col-12 md:col-12 lg:col-6" style={{ alignContent: 'center' }}>
                                                                    {[
                                                                        { label: 'First Name:', value: `${response.FirstName} ${response.LastName}` },
                                                                        { label: 'Email:', value: response.Email },
                                                                        { label: 'Phone:', value: response.Phone },
                                                                        { label: 'SkypeID:', value: response.City },
                                                                        { label: 'Address:', value: `${response.FirstName} ${response.LastName}  ${response.D_No}${response.City} ${response.statename}` },

                                                                    ].map((item, idx) => (
                                                                        <div
                                                                            className="grid"
                                                                            style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}
                                                                            key={idx}
                                                                        >
                                                                            <strong
                                                                                style={{
                                                                                    width: '120px',
                                                                                    textAlign: 'start',
                                                                                    paddingLeft: '30px',
                                                                                    minWidth: '120px',
                                                                                    marginLeft: '50px'
                                                                                }}
                                                                            >
                                                                                {item.label}
                                                                            </strong>
                                                                            <p
                                                                                className="text-muted"
                                                                                style={{
                                                                                    marginLeft: '20px',
                                                                                    width: '280px',
                                                                                    textAlign: 'left'
                                                                                }}
                                                                            >
                                                                                {item.value}
                                                                            </p>
                                                                        </div>
                                                                    ))}
                                                                </div>


                                                                <div className="col-12 md:col-12 lg:col-6">
                                                                    {[
                                                                        { label: 'Hospital:', value: response.hospitalname },
                                                                        { label: 'Speciality:', value: response.SpecilityName },
                                                                        { label: 'ID Card:', value: response.IDCardNumber },
                                                                        { label: 'DateOfBirth:', value: response.DOB },
                                                                        { label: 'Status:', value: response.Status },
                                                                    ].map((item, idx) => (
                                                                        <div className="grid" style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }} key={idx}>
                                                                            <strong style={{ width: '120px', textAlign: 'start', paddingLeft: '30px', marginLeft: '50px' }}>
                                                                                {item.label}
                                                                            </strong>
                                                                            <p className="text-muted" style={{ marginLeft: '20px' }}>{item.value}</p>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </Card>
                                                    </section>
                                                ))}
                                            </div>
                                        </StepperPanel>
                                        <StepperPanel header="Case Details">
                                            <div className="card">
                                                <DataTable value={doc1} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                    globalFilterFields={['FirstName', 'CreateDate', 'CaseStatus', 'SpecilityName']}>
                                                    <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                    <Column header="Patient Name" body={(rowData) => `${rowData.FirstName} `} />
                                                    <Column field="CreateDate" sortable header="Created Date"></Column>
                                                    <Column field="CaseStatus" sortable header="Status"></Column>
                                                    <Column header="Option" body={(rowData) => (
                                                        <div className="options-buttons">
                                                            <Button icon="pi pi-eye" rounded outlined tooltip="View" className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'blue', width: '2rem', height: '2rem' }} onClick={() => ViewCase(rowData)} />
                                                        </div>
                                                    )}></Column>
                                                </DataTable>
                                            </div>
                                        </StepperPanel>
                                        <StepperPanel header="Account Details">
                                            <div className="card">
                                                <DataTable value={doc3} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                    globalFilterFields={['FirstName', 'Amount', 'PaidDate', 'transaction_id']}>
                                                    <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                    <Column header="Patient Name" body={(rowData) => `${rowData.FirstName} `} />
                                                    <Column field="Amount" sortable header="Amount "></Column>
                                                    <Column field="PaidDate" sortable header="Paid Date"></Column>
                                                    <Column field="transaction_id" sortable header="Transaction ID"></Column>
                                                </DataTable>
                                            </div>
                                        </StepperPanel>



                                    </Stepper>
                                </>

                            )}
                        </section >

                    </div >
                </div>
            </div>
        </div>
    )
}
